(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bought-together"] && !Shopify.designMode) return;
  try {
    
(() => {
  const fmtMoney = (cents, format) => {
    if (!format && window.ThemeMoney) return window.ThemeMoney(cents);
    const fmt = format || ('$' + '{' + '{amount}' + '}');
    const n = (Number(cents) || 0) / 100;
    const group = (num, dec, th, ds) => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        case 'amount_with_space_separator': return group(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(n, 0, ' ', ',');
        default: return group(n, 2, ',', '.');
      }
    });
  };

  function setVariant(root, item, opt) {
    if (!opt) return;
    item.dataset.id = opt.value;
    item.dataset.price = opt.dataset.price;
    item.dataset.compare = opt.dataset.compare || 0;
    const price = Number(opt.dataset.price), cmp = Number(opt.dataset.compare || 0);
    const fmt = root.dataset.money;
    const cur = item.querySelector('[data-fbt-price]');
    const old = item.querySelector('[data-fbt-cmp]');
    if (cur) cur.textContent = fmtMoney(price, fmt);
    if (old) { old.hidden = !(cmp > price); old.textContent = cmp > price ? fmtMoney(cmp, fmt) : ''; }
    const box = item.querySelector('.fbt-item__price');
    if (box) box.classList.toggle('price--sale', cmp > price);
    const src = opt.dataset.img;
    if (src) {
      root.querySelectorAll(`.fbt-item[data-index="${item.dataset.index}"] .fbt-item__media img, [data-fbt-thumb="${item.dataset.index}"] img`).forEach((img) => {
        img.removeAttribute('srcset');
        img.src = src;
      });
    }
  }

  function update(root) {
    const fmt = root.dataset.money;
    let total = 0, compare = 0, count = 0;
    root.querySelectorAll('[data-fbt-item]').forEach((item) => {
      const cb = item.querySelector('[data-fbt-check]');
      const on = !!(cb && cb.checked && !cb.disabled);
      item.classList.toggle('is-off', !on);
      root.querySelectorAll(`[data-fbt-thumb="${item.dataset.index}"]`).forEach((t) => t.classList.toggle('is-off', !on));
      if (!on) return;
      const p = Number(item.dataset.price) || 0;
      const c = Number(item.dataset.compare) || 0;
      total += p;
      compare += c > p ? c : p;
      count += 1;
    });
    const set = (sel, fn) => root.querySelectorAll(sel).forEach(fn);
    set('[data-fbt-total]', (el) => { el.textContent = fmtMoney(total, fmt); });
    set('[data-fbt-compare]', (el) => { el.hidden = !(compare > total); el.textContent = compare > total ? fmtMoney(compare, fmt) : ''; });
    set('[data-fbt-save]', (el) => { el.hidden = !(compare > total); });
    set('[data-fbt-save-amount]', (el) => { el.textContent = fmtMoney(compare - total, fmt); });
    set('[data-fbt-count]', (el) => { el.textContent = count; });
    set('[data-fbt-add]', (el) => { el.disabled = count === 0; });
  }

  async function add(root, btn) {
    const ids = [...root.querySelectorAll('[data-fbt-item]')]
      .filter((item) => { const cb = item.querySelector('[data-fbt-check]'); return cb && cb.checked && !cb.disabled; })
      .map((item) => ({ id: Number(item.dataset.id), quantity: 1 }));
    if (!ids.length) return;
    const err = root.querySelector('[data-fbt-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.setAttribute('aria-busy', 'true');
    try {
      if (window.ThemeCart) await window.ThemeCart.add({ items: ids });
      else {
        const res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids }) });
        if (!res.ok) throw new Error((await res.json()).description || 'Error');
        location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      }
      const label = btn.querySelector('[data-fbt-label]');
      if (label && btn.dataset.added) {
        const old = label.textContent;
        label.textContent = btn.dataset.added;
        setTimeout(() => { label.textContent = old; }, 1800);
      }
    } catch (e) {
      if (err) { err.textContent = e.message; err.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }

  async function loadRecs(root) {
    try {
      const res = await fetch(root.dataset.fbtRecs);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-fbt]');
      if (fresh && !fresh.dataset.fbtRecs && fresh.querySelectorAll('[data-fbt-item]').length > 1) {
        root.replaceWith(fresh);
        if (window.ThemeInit) window.ThemeInit(fresh.parentNode || document);
        init(fresh);
        return;
      }
    } catch (e) { /* keep hidden */ }
    if (!(window.Shopify && window.Shopify.designMode)) root.hidden = true;
  }

  function init(root) {
    if (root.dataset.fbtReady) return;
    root.dataset.fbtReady = '1';
    if (root.dataset.fbtRecs) {
      if (!('IntersectionObserver' in window)) { loadRecs(root); return; }
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { io.disconnect(); loadRecs(root); } }), { rootMargin: '600px 0px' });
      io.observe(root.closest('.shopify-section') || root);
      return;
    }
    root.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-fbt-variant]');
      if (sel) setVariant(root, sel.closest('[data-fbt-item]'), sel.options[sel.selectedIndex]);
      update(root);
    });
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-fbt-add]');
      if (btn && !btn.disabled) add(root, btn);
    });
    update(root);
  }

  const boot = (scope) => (scope || document).querySelectorAll('[data-fbt]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));

  // Keep the "this item" row in step with the variant picked in the product form.
  if (!window.__fbtVariantSync) {
    window.__fbtVariantSync = true;
    document.addEventListener('variant:change', (e) => {
      const v = e.detail && e.detail.variant;
      if (!v) return;
      document.querySelectorAll('[data-fbt]').forEach((root) => {
        root.querySelectorAll('[data-fbt-variant]').forEach((sel) => {
          const opt = [...sel.options].find((o) => o.value === String(v.id));
          if (!opt || sel.value === opt.value) return;
          sel.value = opt.value;
          setVariant(root, sel.closest('[data-fbt-item]'), opt);
          const cb = sel.closest('[data-fbt-item]').querySelector('[data-fbt-check]');
          if (cb && opt.disabled) cb.checked = false;
          update(root);
        });
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["callouts"] && !Shopify.designMode) return;
  try {
    
(() => {
  const draw = (wrap) => {
    const stage = wrap.querySelector('.co__stage');
    const fig = wrap.querySelector('.co__figure');
    const svg = wrap.querySelector('.co__lines');
    const sides = [...wrap.querySelectorAll('.co__side')];
    if (wrap.dataset.co !== 'around' || !stage || !fig || !sides.length) return;
    const visible = getComputedStyle(sides[0]).display !== 'none';
    if (!visible) { if (svg) svg.innerHTML = ''; return; }
    const sr = stage.getBoundingClientRect();
    const fr = fig.getBoundingClientRect();
    let out = '';
    sides.forEach((side) => {
      const left = side.classList.contains('co__side--left');
      const cr = side.getBoundingClientRect();
      const items = [...side.querySelectorAll('[data-co-label]')].map((l) => {
        const pin = fig.querySelector(`[data-co-pin="${l.dataset.coLabel}"] .co__pin-dot`);
        const pr = pin.getBoundingClientRect();
        const head = l.querySelector('.co__label-head');
        const hm = head ? head.offsetTop + head.offsetHeight / 2 : 12;
        return { l, pr, hm, h: l.offsetHeight, top: pr.top + pr.height / 2 - cr.top - hm };
      }).sort((a, b) => a.top - b.top);
      const gap = 18;
      let y = 0;
      items.forEach((it) => { it.top = Math.max(it.top, y); y = it.top + it.h + gap; });
      let limit = cr.height;
      for (let i = items.length - 1; i >= 0; i--) {
        const it = items[i];
        if (it.top + it.h > limit) it.top = Math.max(0, limit - it.h);
        limit = it.top - gap;
      }
      items.forEach((it) => {
        it.l.style.top = `${it.top}px`;
        it.l.style.transform = 'none';
        const ay = cr.top - sr.top + it.top + it.hm;
        const ax = left ? cr.right - sr.left + 12 : cr.left - sr.left - 12;
        const ex = left ? fr.left - sr.left + 8 : fr.right - sr.left - 8;
        const px = it.pr.left + it.pr.width / 2 - sr.left;
        const py = it.pr.top + it.pr.height / 2 - sr.top;
        const dx = px - ex; const dy = py - ay; const len = Math.hypot(dx, dy) || 1;
        const r = it.pr.width / 2 + 3;
        const tx = px - (dx / len) * r; const ty = py - (dy / len) * r;
        const d = `M${ax.toFixed(1)} ${ay.toFixed(1)} L${ex.toFixed(1)} ${ay.toFixed(1)} L${tx.toFixed(1)} ${ty.toFixed(1)}`;
        out += `<path class="co__line-halo" d="${d}"/><path class="co__line" d="${d}" data-co-line="${it.l.dataset.coLabel}"/><circle class="co__line-end" cx="${ax.toFixed(1)}" cy="${ay.toFixed(1)}" r="3"/>`;
      });
    });
    if (svg) {
      svg.setAttribute('viewBox', `0 0 ${sr.width.toFixed(1)} ${sr.height.toFixed(1)}`);
      svg.innerHTML = out;
    }
  };

  const highlight = (wrap, n, on) => {
    wrap.querySelectorAll(`[data-co-pin="${n}"], [data-co-label="${n}"], [data-co-item="${n}"], [data-co-line="${n}"]`).forEach((el) => el.classList.toggle('is-hl', on));
  };

  const init = (root) => {
    root.querySelectorAll('[data-co]').forEach((wrap) => {
      if (wrap.dataset.ready) { draw(wrap); return; }
      wrap.dataset.ready = '1';
      wrap.querySelectorAll('[data-co-label], [data-co-item]').forEach((el) => {
        const n = el.dataset.coLabel || el.dataset.coItem;
        el.addEventListener('mouseenter', () => highlight(wrap, n, true));
        el.addEventListener('mouseleave', () => highlight(wrap, n, false));
      });
      wrap.querySelectorAll('button[data-co-pin]').forEach((pin) => {
        pin.addEventListener('click', () => setTimeout(() => {
          wrap.querySelectorAll('.is-hl').forEach((el) => el.classList.remove('is-hl'));
          if (pin.getAttribute('aria-expanded') === 'true') highlight(wrap, pin.dataset.coPin, true);
        }));
      });
      wrap.querySelectorAll('button[data-co-pin][aria-expanded="true"]').forEach((pin) => highlight(wrap, pin.dataset.coPin, true));
      if (wrap.dataset.co === 'around') {
        let raf = 0;
        const run = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => draw(wrap)); };
        if ('ResizeObserver' in window) new ResizeObserver(run).observe(wrap);
        else window.addEventListener('resize', run);
        wrap.querySelectorAll('img').forEach((im) => { if (!im.complete) im.addEventListener('load', run, { once: true }); });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
        run();
      }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const wrap = e.target.closest && e.target.closest('[data-co]');
    if (!wrap) return;
    const n = e.target.dataset.coPin;
    if (e.target.matches('button[data-co-pin]')) {
      wrap.querySelectorAll('button[data-co-pin]').forEach((p) => p.setAttribute('aria-expanded', String(p === e.target)));
    }
    wrap.querySelectorAll('.is-hl').forEach((el) => el.classList.remove('is-hl'));
    if (n) highlight(wrap, n, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  /* SVG <textPath> only renders plain text: flatten any inline markup an editor may have wrapped around the seal text. */
  const init = (root) => root.querySelectorAll('.gb-seal__text textPath').forEach((tp) => { if (tp.children.length) tp.textContent = tp.textContent; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-the-box"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Numbered flat-lay: point to the matching number on the image while a list row is hovered or focused.
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const toggle = (n, on) => {
      root.querySelectorAll(`[data-itb-pin="${n}"], .itb-row[data-itb-n="${n}"]`).forEach((el) => el.classList.toggle('is-active', on));
    };
    root.querySelectorAll('.itb-row[data-itb-n]').forEach((row) => {
      const n = row.dataset.itbN;
      row.addEventListener('mouseenter', () => toggle(n, true));
      row.addEventListener('mouseleave', () => toggle(n, false));
    });
  };
  const boot = (scope) => (scope || document).querySelectorAll('[data-itb]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const pops = () => document.querySelectorAll('details[data-facet-pop][open]');
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.matches('[data-facet-pop]') || !d.open) return;
    pops().forEach((o) => { if (o !== d) o.open = false; });
  }, true);
  document.addEventListener('click', (e) => {
    if (e.target.closest('details[data-facet-pop]')) return;
    pops().forEach((o) => { o.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    pops().forEach((o) => { o.open = false; o.querySelector('summary')?.focus(); });
  });
  // Dim results while a filter or sort form reloads the page.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-facets-form], .facets-sort')) return;
    document.querySelectorAll('[data-mc-results], [data-ms-results]').forEach((r) => r.classList.add('is-loading'));
  });
  window.addEventListener('pageshow', () => document.querySelectorAll('.is-loading[data-mc-results], .is-loading[data-ms-results]').forEach((r) => r.classList.remove('is-loading')));
  // Load more: fetch the next page and append its cards.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-mc-more]');
    if (!btn) return;
    e.preventDefault();
    const wrap = btn.closest('[data-mc-more-wrap]');
    const grid = btn.closest('[data-mc-results]')?.querySelector('[data-mc-grid]');
    if (!grid || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(btn.href);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const freshGrid = doc.querySelector('[data-mc-grid]');
      if (!freshGrid) { location.href = btn.href; return; }
      [...freshGrid.children].forEach((card) => grid.appendChild(card));
      const freshWrap = doc.querySelector('[data-mc-more-wrap]');
      if (freshWrap) wrap.replaceWith(freshWrap); else wrap.remove();
    } catch (err) {
      location.href = btn.href;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__obCopy) return;
  window.__obCopy = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-ob-copy]');
    if (!btn) return;
    e.preventDefault();
    const code = btn.dataset.obCopy || '';
    let ok = false;
    try { await navigator.clipboard.writeText(code); ok = true; } catch (err) {
      const t = document.createElement('textarea');
      t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { ok = document.execCommand('copy'); } catch (e2) {}
      t.remove();
    }
    const label = btn.querySelector('[data-ob-copy-label]');
    if (!label || !ok) return;
    if (!btn.dataset.label) btn.dataset.label = label.textContent;
    label.textContent = btn.dataset.copied || 'Copied';
    btn.classList.add('is-copied');
    clearTimeout(btn._t);
    btn._t = setTimeout(() => { label.textContent = btn.dataset.label; btn.classList.remove('is-copied'); }, 2000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["problem-solution"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-ps-buy]').forEach((a) => {
      if (a.dataset.ready) return;
      a.dataset.ready = '1';
      a.addEventListener('click', (e) => {
        const target = document.querySelector('.main-product [data-product-form]') || document.querySelector('.main-product');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusable = target.querySelector('button[name="add"], button[type="submit"], select, input:not([type="hidden"])');
        if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 450);
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cta"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Swap the section image when the shopper picks a variant with its own photo (theme.js handles price, id and buttons).
  const pick = (v) => {
    const m = v && v.featured_media && v.featured_media.preview_image;
    let src = (m && m.src) || (v && v.featured_image && (v.featured_image.src || v.featured_image)) || '';
    if (typeof src !== 'string' || !src) return '';
    if (src.startsWith('//')) src = 'https:' + src;
    return src;
  };
  const init = (root) => {
    if (root.dataset.pctaReady) return;
    root.dataset.pctaReady = '1';
    if (!root.hasAttribute('data-pcta-swap')) return;
    root.addEventListener('variant:change', (e) => {
      if (e.target !== root) return;
      const src = pick(e.detail && e.detail.variant);
      if (!src) return;
      root.querySelectorAll('[data-pcta-img] img').forEach((img) => {
        const url = src + (src.includes('?') ? '&' : '?') + 'width=' + (img.closest('.pcta-split__media, .pcta-ov__media') ? 1400 : 400);
        if (img.src === url) return;
        img.removeAttribute('srcset');
        img.src = url;
      });
    });
  };
  const boot = (scope) => (scope || document).querySelectorAll('.pcta[data-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(() => {
  // The carousel is set up only once theme.js has filled it with the shopper's products.
  const setup = (root) => {
    root.querySelectorAll('[data-rv-carousel]:not([data-carousel])').forEach((c) => {
      const items = c.querySelector('[data-recently-viewed-items]');
      if (!items) return;
      const go = () => {
        if (!items.children.length || c.hasAttribute('data-carousel')) return;
        c.setAttribute('data-carousel', '');
        if (window.ThemeInit) window.ThemeInit(c.parentNode);
      };
      go();
      new MutationObserver(go).observe(items, { childList: true });
    });
  };
  const run = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', (e) => setup(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-nav"] && !Shopify.designMode) return;
  try {
    
(() => {
  const headerOffset = () => {
    const h = document.querySelector('[data-sticky-header]');
    if (!h || h.classList.contains('is-hidden')) return 0;
    const r = h.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  };
  function init(nav) {
    if (nav.dataset.ready) return;
    nav.dataset.ready = '1';
    const list = nav.querySelector('[data-snav-list]');
    const host = nav.closest('.shopify-section');
    if (nav.dataset.snav === 'auto' && list && host) {
      list.innerHTML = '';
      let el = host.nextElementSibling;
      while (el) {
        if (el.classList.contains('shopify-section') && el.id && el.offsetHeight > 40) {
          const h = el.querySelector('h2, .h2, .h1');
          const text = h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
          if (text && text.length < 60) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.className = 'snav__link'; a.href = `#${el.id}`; a.dataset.snavLink = ''; a.textContent = text;
            li.appendChild(a); list.appendChild(li);
          }
        }
        el = el.nextElementSibling;
      }
    }
    const links = [...nav.querySelectorAll('[data-snav-link]')];
    if (list) {
      const clip = () => { list.classList.toggle('is-clipped', list.scrollWidth > list.clientWidth + 2); list.classList.toggle('is-end', list.scrollLeft + list.clientWidth >= list.scrollWidth - 2); };
      list.addEventListener('scroll', clip, { passive: true }); addEventListener('resize', clip); requestAnimationFrame(clip);
    }
    if (!links.length) { nav.dataset.empty = ''; return; }
    const targets = links.map((a) => document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)))).filter(Boolean);
    const bar = nav.querySelector('[data-snav-bar]');
    const offset = () => headerOffset() + (nav.classList.contains('is-fixed') ? bar.offsetHeight : 0) + 8;
    links.forEach((a) => a.addEventListener('click', (e) => {
      const t = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (!t) return;
      e.preventDefault();
      scrollTo({ top: t.getBoundingClientRect().top + scrollY - offset() - (nav.dataset.snavLayout === 'bar' && !nav.classList.contains('is-fixed') ? bar.offsetHeight : 0), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    const setActive = () => {
      const line = offset() + 40;
      let current = null;
      targets.forEach((t) => { if (t.getBoundingClientRect().top <= line) current = t; });
      links.forEach((a) => {
        const on = current && a.getAttribute('href') === `#${current.id}`;
        if (on !== a.classList.contains('is-active')) {
          a.classList.toggle('is-active', on);
          if (on) a.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    };
    const update = () => {
      if (nav.dataset.snavLayout === 'bar') {
        const top = headerOffset();
        nav.style.setProperty('--snav-top', `${top}px`);
        const start = nav.getBoundingClientRect().top;
        const last = targets[targets.length - 1];
        const end = last ? last.getBoundingClientRect().bottom : Infinity;
        const fixed = start < top && end > top + 120;
        if (fixed && !nav.classList.contains('is-fixed')) nav.style.setProperty('--snav-h', `${bar.offsetHeight}px`);
        nav.classList.toggle('is-fixed', fixed);
      }
      setActive();
    };
    let raf = 0;
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; update(); }); }, { passive: true });
    addEventListener('resize', update);
    update();
    const buy = nav.querySelector('[data-snav-buy]');
    if (buy) buy.addEventListener('click', () => {
      const form = document.querySelector('.main-product [data-product-form]') || document.querySelector('[data-product-form]');
      if (!form) return;
      const picker = form.closest('[data-product]');
      const needsChoice = picker && picker.querySelector('[data-option-index]') && !form.querySelector('[name="id"]')?.value;
      if (form.requestSubmit && !needsChoice) form.requestSubmit();
      else form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  const run = (scope) => scope.querySelectorAll('[data-snav]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document)); else run(document);
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__stlHover) return;
  window.__stlHover = true;
  const toggle = (e, on) => {
    const item = e.target.closest && e.target.closest('[data-stl-item]');
    if (!item) return;
    const scope = item.closest('.stl-slide, .stl-split, .stl') || document;
    const dot = scope.querySelector(`[data-stl-dot="${item.dataset.stlItem}"]`);
    if (dot) dot.classList.toggle('is-hl', on);
  };
  document.addEventListener('mouseover', (e) => toggle(e, true));
  document.addEventListener('mouseout', (e) => toggle(e, false));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-slideshow]').forEach((el) => {
      if (el.dataset.ssReady) return;
      el.dataset.ssReady = '1';
      const root = el.closest('.slideshow');
      const track = el.querySelector('[data-carousel-track]');
      if (!track || !root) return;
      const slides = [...track.children];
      const current = el.querySelector('[data-ss-current]');
      const pad = (n) => String(n).padStart(2, '0');
      let active = -1;
      const update = () => {
        const x = track.scrollLeft;
        let idx = 0;
        let best = Infinity;
        slides.forEach((sl, i) => {
          const d = Math.abs(sl.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0) - x);
          if (d < best) { best = d; idx = i; }
        });
        if (idx === active) return;
        active = idx;
        slides.forEach((sl, i) => sl.classList.toggle('is-active', i === idx));
        if (current) current.textContent = pad(idx + 1);
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      addEventListener('resize', update);
      update();
      root.classList.add('is-ready');

      const pause = el.querySelector('[data-ss-pause]');
      if (pause) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { pause.hidden = true; return; }
        let paused = false;
        el.addEventListener('mouseleave', (e) => { if (paused) e.stopImmediatePropagation(); }, true);
        pause.addEventListener('click', () => {
          paused = !paused;
          pause.setAttribute('aria-pressed', String(paused));
          el.dispatchEvent(new Event(paused ? 'mouseenter' : 'mouseleave'));
        });
      }
    });
  };
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest && e.target.closest('[data-slide]');
    const track = slide && slide.parentElement;
    if (track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
(() => {
  const run = (el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const m = /^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/.exec(el.textContent.trim());
    if (!m || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const [, pre, num, post] = m;
    const target = parseFloat(num.replace(/,/g, ''));
    const decimals = (num.split('.')[1] || '').length;
    const commas = num.includes(',');
    const fmt = (v) => { const t = v.toFixed(decimals); return commas ? Number(t).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : t; };
    const final = el.textContent;
    el.style.minWidth = el.offsetWidth + 'px';
    el.textContent = pre + fmt(0) + post;
    const io = new IntersectionObserver(([en]) => {
      if (!en.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / 1400);
        const e = 1 - Math.pow(1 - p, 3);
        el.textContent = p < 1 ? pre + fmt(target * e) + post : final;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }, { threshold: .4 });
    io.observe(el);
  };
  const init = (root) => root.querySelectorAll('[data-count-up]').forEach(run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-rows"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-story]').forEach((box) => {
      if (box.dataset.ready) return;
      const rows = [...box.querySelectorAll('[data-story-row]')];
      const imgs = [...box.querySelectorAll('[data-story-img]')];
      if (!rows.length || !('IntersectionObserver' in window)) return;
      box.dataset.ready = '1';
      const set = (i) => {
        rows.forEach((r, j) => r.classList.toggle('is-active', j === i));
        imgs.forEach((im, j) => im.classList.toggle('is-active', j === i));
        box.style.setProperty('--active', i);
      };
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) set(Number(en.target.dataset.index)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      rows.forEach((r) => io.observe(r));
    });
  };
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SEL = '[data-ugc]';
  const active = new Set();
  const stopOthers = (keep) => {
    document.querySelectorAll('[data-ugc-card] video').forEach((v) => { if (v !== keep && !v.paused) v.pause(); });
  };
  const mount = (card) => {
    let v = card.querySelector('video');
    if (v) return v;
    const tpl = card.querySelector('template[data-ugc-video]');
    if (!tpl) return null;
    card.querySelector('[data-ugc-stage]').appendChild(tpl.content.cloneNode(true));
    v = card.querySelector('video');
    if (!v) return null;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.addEventListener('play', () => { card.classList.add('is-playing'); if (!v.muted) { active.add(v); stopOthers(v); } });
    v.addEventListener('pause', () => { card.classList.remove('is-playing'); active.delete(v); });
    v.addEventListener('ended', () => { card.classList.remove('is-playing', 'is-open'); active.delete(v); });
    v.addEventListener('volumechange', () => { if (!v.muted && !v.paused) { active.add(v); stopOthers(v); } });
    return v;
  };
  const play = (card) => {
    const v = mount(card);
    if (!v) return;
    card.classList.add('is-open');
    v.loop = false;
    v.muted = false;
    v.controls = true;
    stopOthers(v);
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
    v.focus({ preventScroll: true });
  };
  const init = (root) => {
    root.querySelectorAll(SEL).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      sec.querySelectorAll('[data-ugc-play]').forEach((btn) => btn.addEventListener('click', () => play(btn.closest('[data-ugc-card]'))));
      if (!sec.hasAttribute('data-ugc-autoplay') || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const io = new IntersectionObserver((entries) => entries.forEach((en) => {
        const card = en.target;
        if (card.classList.contains('is-open')) { if (!en.isIntersecting) { const v = card.querySelector('video'); if (v) v.pause(); } return; }
        if (en.isIntersecting && active.size === 0) {
          const v = mount(card);
          if (!v) return;
          v.muted = true; v.loop = true; v.controls = false;
          const p = v.play(); if (p && p.catch) p.catch(() => {});
        } else if (!en.isIntersecting) {
          const v = card.querySelector('video'); if (v) v.pause();
        }
      }), { threshold: 0.6 });
      sec.querySelectorAll('[data-ugc-card]').forEach((c) => { if (c.querySelector('template[data-ugc-video]')) io.observe(c); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ytCmd = (iframe, func) => iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func, args: '' }), '*');
  const vmCmd = (iframe, method) => iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({ method }), '*');
  const setPlaying = (player, playing) => {
    const el = player.querySelector('.video__el');
    if (!el) return;
    if (el.tagName === 'VIDEO') { if (playing) el.play().catch(() => {}); else el.pause(); }
    else if (player.dataset.src === 'youtube') ytCmd(el, playing ? 'playVideo' : 'pauseVideo');
    else if (player.dataset.src === 'vimeo') vmCmd(el, playing ? 'play' : 'pause');
    const t = player.querySelector('[data-video-toggle]');
    if (t) t.setAttribute('aria-pressed', String(!playing));
  };
  const init = (scope) => {
    scope.querySelectorAll('[data-video-player]').forEach((player) => {
      if (player.dataset.ready) return;
      player.dataset.ready = '1';
      const play = player.querySelector('[data-video-play]');
      const tpl = player.querySelector('[data-video-template]');
      const embed = player.querySelector('[data-video-embed]');
      if (play && tpl && embed) {
        play.addEventListener('click', () => {
          embed.innerHTML = '';
          embed.appendChild(tpl.content.cloneNode(true));
          player.classList.add('is-playing');
          const v = embed.querySelector('video');
          if (v) { v.play().catch(() => {}); v.focus(); } else { const f = embed.querySelector('iframe'); if (f) f.focus(); }
        });
      }
      const toggle = player.querySelector('[data-video-toggle]');
      if (toggle) {
        toggle.addEventListener('click', () => setPlaying(player, toggle.getAttribute('aria-pressed') === 'true'));
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const v = player.querySelector('video');
          if (v) { v.removeAttribute('autoplay'); v.pause(); toggle.setAttribute('aria-pressed', 'true'); }
        }
      }
    });
  };
  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["who-for"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-wf-buy]').forEach((a) => {
      if (a.dataset.ready) return;
      a.dataset.ready = '1';
      a.addEventListener('click', (e) => {
        const target = document.querySelector('.main-product [data-product-form]') || document.querySelector('.main-product');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusable = target.querySelector('button[name="add"], button[type="submit"], select, input:not([type="hidden"])');
        if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 450);
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
